import type { ReactNode } from "react";

import {
  ThinkingEmojiIcon,
  ThumbDownEmojiIcon,
  ThumbUpEmojiIcon,
} from "@braintrust/braintrust-ui-components/Icons";

export type BidReaction = {
  icon: ReactNode;
  title: string;
  value: EnumType<typeof ENUMS.BidReactionType> | undefined;
};

export const BID_REACTIONS: BidReaction[] = [
  {
    icon: <ThumbUpEmojiIcon id="Thumbs up" />,
    title: "Like",
    value: "thumbs_up",
  },
  {
    icon: <ThinkingEmojiIcon id="Thinking" />,
    title: "Thinking",
    value: "thinking",
  },
  {
    icon: <ThumbDownEmojiIcon id="Thumbs down" />,
    title: "Dislike",
    value: undefined,
  },
];
